import React from 'react';
import TitleAndInfo from "./preview/TitleAndInfo";
import trash from "../../../media/icons/trash.svg";
import edit from "../../../media/icons/edit.svg"
import download from "../../../media/icons/download.svg"
import ModalCancelation from "./ModalCancelation";
import ModalBooking from "./ModalBooking";
import { ToolTip } from "../../shared/allToolTips";
import { modelsConsWrapper } from "../../wrappers/modelsConsWrapper";
import rentalContractEn from "./../../../media/documents/rentalContractEn.pdf"
import rentalContractEs from "./../../../media/documents/rentalContractEs.pdf"
import { PDFDocument, StandardFonts } from 'pdf-lib';

const moment = require('moment');

const RENTAL_AGREEMENT_FIELD_FONT_SIZE = 9;

const ModalPreviewBooking = ({ info, changeModal, refreshRentals, models }) => {
  const { user, leaveIt, pickUp, booking, rental, payMethod } = info;
  const isCanceled = booking.status === "canceled";
  const paymentIntent = booking?.payment?.intentId
  const model = models?.[rental.model._id]

  const getModalCancelation = () => {
    changeModal(<ModalCancelation changeModal={changeModal} booking={booking} afterCancel={refreshRentals}/>)
  };

  const getModalModify = () => {
    changeModal(<ModalBooking changeModal={changeModal} booking={booking} afterUpdate={refreshRentals}/>)
  };

  const downloadRentalAgreement = async (language = "en") => {
    const contracts = {
      en: rentalContractEn,
      es: rentalContractEs
    }
    const existingPdfBytes = await fetch(contracts[language]).then(res => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const form = pdfDoc.getForm();

    const rentalId = form.getTextField('rentalId');
    // customer section
    const customerName = form.getTextField('customerName');
    const customerSurname = form.getTextField('customerSurname');
    const customerAddress = form.getTextField('customerAddress');
    const customerCity = form.getTextField('customerCity');
    const customerPostalCode = form.getTextField('customerPostalCode');
    const customerCountry = form.getTextField('customerCountry');
    const customerPhone = form.getTextField('customerPhone');
    const customerBirthDate = form.getTextField('customerBirthDate');
    const customerEmail = form.getTextField('customerEmail');
    const customerDrivingLicense = form.getTextField('customerDrivingLicense');
    const customerPassport = form.getTextField('customerPassport');
    const customerDeliveryAddress = form.getTextField('customerDeliveryAddress');
    const customerDeliveryCity = form.getTextField('customerDeliveryCity');
    const customerDeliveryPostalCode = form.getTextField('customerDeliveryPostalCode');
    // vehicle
    const vehicleNumberPlate = form.getTextField('vehicleNumberPlate');
    const vehicleNumber = form.getTextField('vehicleNumber');
    const vehicleKm = form.getTextField('vehicleKm');
    // start section
    const startDate = form.getTextField('startDate');
    const startTime = form.getTextField('startTime');
    const startPlace = form.getTextField('startPlace');
    // return section
    const returnDate = form.getTextField('returnDate');
    const returnTime = form.getTextField('returnTime');
    const returnPlace = form.getTextField('returnPlace');
    // charges
    const chargesVespa = form.getTextField('chargesVespa');
    const chargesFullInsurance = form.getTextField('chargesFullInsurance');
    const chargesMap = form.getTextField('chargesMap');
    const chargesSmartphoneHolder = form.getTextField('chargesSmartphoneHolder');
    const chargesCollectionAndDelivery = form.getTextField('chargesCollectionAndDelivery');
    const chargesTotalAmount = form.getTextField('chargesTotalAmount');
    // Payment method
    const paymentMethodCreditCard = form.getCheckBox('paymentMethodCreditCard');
    const paymentMethodOnline = form.getCheckBox('paymentMethodOnline');
    const paymentMethodCash = form.getCheckBox('paymentMethodCash');
    // Credit card deposit
    const creditCardDepositVisa = form.getCheckBox('creditCardDepositVisa');
    const creditCardDepositMastercard = form.getCheckBox('creditCardDepositMastercard');
    const creditCardDepositAmex = form.getCheckBox('creditCardDepositAmex');
    const creditCardNumber = form.getTextField('creditCardNumber');
    const creditCardValidUntil = form.getTextField('creditCardValidUntil');
    const creditCardCardholderName = form.getTextField('creditCardCardholderName');
    // Comments
    const comments = form.getTextField('comments');
    // Signatures
    const signature = form.getTextField('signature');
    const signature2 = form.getTextField('signature2');

    const textFields = [
      rentalId,
      customerName,
      customerSurname,
      customerAddress,
      customerCity,
      customerPostalCode,
      customerCountry,
      customerPhone,
      customerBirthDate,
      customerEmail,
      customerDrivingLicense,
      customerPassport,
      customerDeliveryAddress,
      customerDeliveryCity,
      customerDeliveryPostalCode,
      vehicleNumberPlate,
      vehicleNumber,
      vehicleKm,
      startDate,
      startTime,
      startPlace,
      returnDate,
      returnTime,
      returnPlace,
      chargesVespa,
      chargesFullInsurance,
      chargesMap,
      chargesSmartphoneHolder,
      chargesCollectionAndDelivery,
      chargesTotalAmount,
      creditCardNumber,
      creditCardValidUntil,
      creditCardCardholderName,
      comments,
      signature,
      signature2,
    ];

    rentalId.setText("")

    customerName.setText(user.name || "")
    customerSurname.setText(user.surname || "")
    customerAddress.setText(user.address || "")
    customerCity.setText(user.city || "")
    customerPostalCode.setText(user.cp || "")
    customerCountry.setText(user.country || "")
    customerPhone.setText(user.phone || "")
    customerBirthDate.setText(user.birthDate || "")
    customerEmail.setText(user.email || "")
    customerDrivingLicense.setText(user.driversLicense || "")
    customerPassport.setText(user.passport || "")


    customerDeliveryAddress.setText(pickUp.adress || "")
    customerDeliveryCity.setText(pickUp.location || "")
    customerDeliveryPostalCode.setText(pickUp.cp || "")

    vehicleNumberPlate.setText(rental.licensePlate || "")
    vehicleNumber.setText(rental.vehicleNumber || "")
    vehicleKm.setText(rental.vehicleKm || "")

    startDate.setText(pickUp.date ? moment(pickUp.date).locale(language).format("L") : "")
    startTime.setText(pickUp.date ? moment(pickUp.date).locale(language).format("LT") : "")
    startPlace.setText([pickUp.adress, pickUp.location, pickUp.cp].filter((t) => !!t).join(", "))

    returnDate.setText(leaveIt.date ? moment(leaveIt.date).locale(language).format("L") : "")
    returnTime.setText(leaveIt.date ? moment(leaveIt.date).locale(language).format("LT") : "")
    returnPlace.setText([leaveIt.adress, leaveIt.location, leaveIt.cp].filter((t) => !!t).join(", "))

    chargesVespa.setText("")
    chargesFullInsurance.setText("")
    chargesMap.setText("")
    chargesSmartphoneHolder.setText("")
    chargesCollectionAndDelivery.setText("")
    chargesTotalAmount.setText("")

    if(payMethod === "card payment") paymentMethodCreditCard.check()
    else paymentMethodCreditCard.uncheck()
    paymentMethodCash.uncheck()
    paymentMethodOnline.uncheck()

    creditCardDepositVisa.uncheck()
    creditCardDepositMastercard.uncheck()
    creditCardDepositAmex.uncheck()
    creditCardNumber.setText("")
    creditCardValidUntil.setText("")
    creditCardCardholderName.setText("")

    comments.setText(`${pickUp?.comments ? `DELIVERY: ${pickUp?.comments}` : ""} ${leaveIt?.comments ? `RETURN: ${leaveIt?.comments}` : ""}`)

    signature.setText("")
    signature2.setText("")

    const textFieldFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

    textFields.forEach(field => {
      try {
        field.setFontSize(RENTAL_AGREEMENT_FIELD_FONT_SIZE);
        field.acroField.getWidgets().forEach(widget => {
          widget.setDefaultAppearance(`0 0 0 rg\n/Helvetica ${RENTAL_AGREEMENT_FIELD_FONT_SIZE} Tf`);
        });
        field.updateAppearances(textFieldFont);
      } catch (error) {
        console.warn(`Unable to update PDF field font size for ${field.getName()}`, error);
      }
    });

    const pdfBytes = await pdfDoc.save();
    const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });

    // Crear un enlace de descarga dinámico
    const link = document.createElement('a');
    link.href = URL.createObjectURL(pdfBlob);
    link.download = 'Rental Agreement.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  }

  const getPayMethod = (payMethod) => {
    switch (payMethod) {
      case "cash":
        return "Efectivo";
      case "wire transfer":
        return "Transferencia Bancaria";
      case "card payment":
        return "Pago con tarjeta Crédito / Debito";
      default:
        return payMethod;
    }
  };

  const getStatus = () => {
    switch (booking.status) {
      case "processing":
        return "En proceso";
      case "succeeded":
      case "secceeded":
        return "Transacción realizada";
      case "doubtful":
        return "Transacción procesandose en stripe";
      case "canceled":
        return "Transacción cancelada";
      default:
        return "En proceso";
    }
  };

  return (
    <div className="bg-white p-5" style={{ minWidth: "300px", width: "90vw", maxWidth: "1500px", minHeight: "200px" }}>
      <div style={{ fontSize: "20px" }} className="row justify-content-between text-center mb-2">
        {info.user.name + " " + info.user.surname}
        <div>
          {getStatus()}
        </div>
      </div>
      <div className="row justify-content-end mb-4">
        <ToolTip.ModifyBooking/>
        <div
          data-tip={true}
          data-for='modifyBooking'
          className="mx-1 d-flex"
        >
          <img onClick={!isCanceled ? getModalModify : () => {
          }} style={{ cursor: (!isCanceled ? "pointer" : "auto"), opacity: (!isCanceled ? 1 : 0.5) }}
               width="20px" height="20px"
               src={edit} alt=""/>
        </div>
        <ToolTip.DownloadRentalAgreement/>
        <div
          className="mx-1 d-flex"
          data-tip={true}
          data-for='downloadRentalAgreement'
          style={{ cursor: "pointer" }}
        >
          <img
            onClick={() => downloadRentalAgreement("es")}
            width="20px" height="20px"
            src={download}
            alt=""
          />
          <small style={{
            textOrientation: "upright",
            writingMode: "vertical-rl",
            letterSpacing: -7,
            lineHeight: 1,
            marginTop: -5,
            marginLeft: -5,
            userSelect: "none"
          }}>
            ES
          </small>
        </div>
        <ToolTip.DownloadRentalAgreement/>
        <div
          className="mx-1 d-flex"
          data-tip={true}
          data-for='downloadRentalAgreement'
          style={{ cursor: "pointer" }}
        >
          <img
            onClick={() => downloadRentalAgreement("en")}
            width="20px" height="20px"
            src={download}
            alt=""
          />
          <small style={{
            textOrientation: "upright",
            writingMode: "vertical-rl",
            letterSpacing: -7,
            lineHeight: 1,
            marginTop: -5,
            marginLeft: -4,
            userSelect: "none"
          }}>
            EN
          </small>
        </div>
        <ToolTip.CancelBooking/>
        <div
          data-tip={true}
          data-for='cancelBooking'
          className="mx-1 d-flex"
        >
          <img onClick={!isCanceled ? getModalCancelation : () => {
          }} style={{ cursor: (!isCanceled ? "pointer" : "auto"), opacity: (!isCanceled ? 1 : 0.5) }}
               width="20px" height="20px" src={trash} alt=""/>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-6">
          <div className="row mr-md-2 bg-white">
            <div className="col-12">
              <TitleAndInfo title="Nombre" children={user.name}/>
              <TitleAndInfo title="Apellidos" children={user.surname}/>
              <TitleAndInfo title="Dirección" children={user.address}/>
              <TitleAndInfo title="CP" children={user.cp}/>
              <TitleAndInfo title="Localidad" children={user.location}/>
              <TitleAndInfo title="Ciudad" children={user.city}/>
              <TitleAndInfo title="País" children={user.country}/>
              <TitleAndInfo title="Nacionalidad" children={user.nationality}/>
              <TitleAndInfo title="Nº pasaporte o ID" children={user.passport}/>
              <TitleAndInfo title="Nº licencia de conducir" children={user.driversLicense}/>
              <TitleAndInfo title="Teléfono" children={user.phone}/>
              <TitleAndInfo title="Correo electrónico" children={user.email}/>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 mt-5 mt-md-0">
          <div className="row ml-md-2 bg-white">
            <div className="col-12">
              <TitleAndInfo title="Recogida" children={moment(pickUp.date).format("DD [/] M [/] YYYY [|] HH:mm [h.]")}/>
              <TitleAndInfo title="Lugar recogida"
                            children={pickUp.delivery ? (" - " + pickUp.adress + " / " + pickUp.location + " / " + pickUp.cp) : "En tienda"}/>
              <TitleAndInfo title="Comentarios"
                            children={pickUp.comments || "..."}/>
              <TitleAndInfo title="Devolución"
                            children={moment(leaveIt.date).format("DD [/] M [/] YYYY [|] HH:mm [h.]")}/>
              <TitleAndInfo title="Lugar devolución"
                            children={leaveIt.delivery ? (leaveIt.samePlace ? "Mismo lugar que entrega" : (" - " + leaveIt.adress + " / " + leaveIt.location + " / " + leaveIt.cp)) : "En tienda"}/>
              <TitleAndInfo title="Comentarios"
                            children={leaveIt.comments || "..."}/>
              <TitleAndInfo title="Días" children={booking.days}/>
              <TitleAndInfo title="Importe" children={booking.totalPrice.toFixed(2) + " €"}/>
              <TitleAndInfo title="Metodo de pago" children={getPayMethod(payMethod)}/>
              {paymentIntent && (
                <TitleAndInfo title="Pago en stripe" children={(
                  <a className="ml-1" rel="noreferrer" href={`https://dashboard.stripe.com/payments/${paymentIntent}`}
                     target="_blank"
                     children={"🔗 " + paymentIntent}/>
                )}/>
              )}
              <TitleAndInfo title="Nº vespas" children={booking.rentals.length}/>
              <div className="row justify-content-center mt-5">
                <div style={{ minWidth: "280px", maxWidth: "350px" }} className="col">
                  <div className="row justify-content-center">
                    {model?.image && <img width="100%" height="100%" src={model.image.main} alt=""/>}
                  </div>
                </div>
                <div style={{ minWidth: "300px" }} className="col">
                  <TitleAndInfo title="Vespa" children={rental.model.name + " " + rental.model.cubicCapacity}/>
                  <TitleAndInfo title="Matricula" children={rental.licensePlate}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default modelsConsWrapper(ModalPreviewBooking);
